<template>
	<div class="menu-bar-container" v-if="tipTapEditor">
		<div class="menu-bar px-2 d-flex flex-wrap align-items-center justify-content-between">
			<div class="button-list d-flex align-items-center">
				<label
					v-if="extended"
					class="menu-button"
					:class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
					@click="handleHeadingClick"
				>
					<InlineSvg src="/images/icons/ic-font-size.svg" />
				</label>
				<label class="menu-button" :class="{ 'is-active': editor.isActive('bold') }" @click="handleBoldClick">
					<InlineSvg src="/images/icons/ic-bold.svg" />
				</label>
				<label class="menu-button" :class="{ 'is-active': editor.isActive('strike') }" @click="handleStrikeClick">
					<InlineSvg src="/images/icons/ic-strike.svg" />
				</label>
				<label class="menu-button" :class="{ 'is-active': editor.isActive('italic') }" @click="handleItalicClick">
					<InlineSvg src="/images/icons/ic-italic.svg" />
				</label>
				<label class="menu-button" :class="{ 'is-active': editor.isActive('bulletList') }" @click="handleBulletListClick">
					<InlineSvg src="/images/icons/ic-list.svg" />
				</label>
				<label class="menu-button" @click="addImage" v-if="showImage">
					<InlineSvg src="/images/icons/ic-image.svg" />
				</label>
				<label class="menu-button" @click="addLoomVideo" v-if="showVideoEmbed">
					<InlineSvg src="/images/icons/ic-video.svg" />
				</label>
				<label class="menu-button" @click="setLink" v-if="showLink">
					<InlineSvg src="/images/icons/ic-link.svg" />
				</label>
				<label class="menu-button" @click="addCountdownTimer" v-if="showCountdownTimer">
					<InlineSvg src="/images/icons/ic-clock.svg" />
				</label>
				<AppButton
					v-if="showGenerateWithAI"
					name="tiptap-editor-ai-assistance"
					class="inverse tiptap-editor-ai-button ml-0 pl-0"
					size="sm"
					link
					type="button"
					icon="images/icons/ic-ai-generate.svg"
					:loading="isAISuggestionLoading"
					:disabled="isAISuggestionLoading"
					@click="toggleAIPrompt"
					:color="error ? 'danger' : 'primary'"
				>
					<span class="ai-button-text">Generate with AI</span>
				</AppButton>
			</div>
			<AppButton
				v-if="showDone"
				name="finished-editing-toolbar-button"
				class="inverse done-button"
				size="sm"
				pill
				type="button"
				@click="doneEditing"
				outline
			>
				Done
			</AppButton>
			<div class="d-flex px-0 ml-auto" v-if="fart">
				<AppDropdownMenu class=" flex-auto" v-if="showPersonalize && !showPersonalizeAtBottom && variableItemsData">
					<AppButton name="tiptap-editor-personalize" class="inverse" size="sm" outline type="button" icon="images/icons/ic-plus.svg">
						Personalize
					</AppButton>
					<template v-slot:content>
						<button
							class="dropdown-item"
							type="button"
							v-for="item in sortedVariableItemsData"
							:key="item.id"
							@click="handleVariableItemClick(item)"
						>
							{{ item.name }}
						</button>
					</template>
				</AppDropdownMenu>
				<AppButton
					v-if="showProductList"
					name="tiptap-editor-product-link"
					class="inverse"
					size="sm"
					outline
					type="button"
					icon="images/icons/ic-link.svg"
					@click="openProductSelectionModal"
				>
					Add Product Link
				</AppButton>

				<AIPromptBox v-if="showAIPrompt" v-on-click-outside="closeAIPrompt" @requestAIAssistance="requestAIAssistance" />
			</div>
		</div>
	</div>
</template>
<script>
	import { debounce } from 'lodash'

	export default {
		props: {
			tipTapEditor: {
				type: Object,
				required: false,
			},
			showProductList: {
				type: Boolean,
				default: false,
			},
			showImage: {
				type: Boolean,
				default: false,
			},
			showVideoEmbed: {
				type: Boolean,
				default: false,
			},
			showLink: {
				type: Boolean,
				default: false,
			},
			showCountdownTimer: {
				type: Boolean,
				default: false,
			},
			showDone: {
				type: Boolean,
				default: false,
			},
			showGenerateWithAI: {
				type: Boolean,
				default: false,
			},
			showPersonalize: {
				type: Boolean,
				default: false,
			},
			showPersonalizeAtBottom: {
				type: Boolean,
				default: false,
			},
			variableItemsData: {
				type: Array,
				default: () => [],
			},
			extended: {
				type: Boolean,
				default: false,
			},
			error: {
				type: Boolean,
				default: false,
			},
			editorFileUploadRef: {
				type: String,
				default: '',
			},
			editorFileUploadVideoRef: {
				type: String,
				default: '',
			},
			insertVideoRef: {
				type: String,
				default: '',
			},
			linkRef: {
				type: String,
				default: '',
			},
			countdownTimerModalRef: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				isAISuggestionLoading: false,
				showAIPrompt: false,
				isAIAssistanceRequested: false,
				aiSuggestionAcceptedTransition: false,
				lastPrompt: '',
				fixPosition: 0,
				lastScrollY: 0,
			}
		},
		computed: {
			editor() {
				return this.tipTapEditor?.editor
			},
			sortedVariableItemsData() {
				return [...(this.variableItemsData || [])].sort((a, b) => (a.name > b.name ? 1 : -1))
			},
			fart() {
				return (this.showPersonalize && !this.showPersonalizeAtBottom && this.variableItemsData) || this.showProductList || this.showAIPrompt
			},
		},
		mounted() {
			this.lastScrollY = window.pageYOffset
			window.addEventListener('scroll', this.showToolbar)
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.showToolbar)
		},
		methods: {
			setMargin: debounce(function setMarginFn() {
				const toolbarWrap = this.$el
				const toolbar = this.$el.querySelector('.menu-bar')

				if (!toolbarWrap || !toolbar) return

				const newPosition = toolbarWrap.getBoundingClientRect().top
				if (newPosition < -1) {
					toolbar.classList.add('down')
					this.fixPosition = Math.abs(newPosition)

					// Adjust for bottom of page
					if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {
						this.fixPosition -= 2
					}

					toolbar.style.marginTop = `${this.fixPosition}px`
				}
			}, 150),

			showToolbar() {
				const toolbar = this.$el?.querySelector('.menu-bar')
				if (!toolbar) return

				if (this.fixPosition > 0) {
					toolbar.classList.remove('down')
					this.fixPosition = 0
					toolbar.style.marginTop = '0px'
				}

				this.setMargin()
			},
			addImage() {
				this.tipTapEditor?.$refs['editor-file-upload']?.onPickFile()
			},
			addVideo() {
				this.filesUploading += 1
				this.tipTapEditor?.$refs['editor-file-upload-video']?.onPickFile()
			},
			addLoomVideo() {
				this.tipTapEditor?.$refs[this.tipTapEditor.insertVideoRef]?.onLoad()
			},
			setLink() {
				this.tipTapEditor?.$refs[this.tipTapEditor.linkRef]?.onLoad()
			},
			addCountdownTimer() {
				this.tipTapEditor?.$refs['countdown-timer-modal']?.onLoad()
			},
			closeAIPrompt() {
				this.showAIPrompt = false
			},
			toggleAIPrompt() {
				this.showAIPrompt = !this.showAIPrompt
			},
			requestAIAssistance(prompt) {
				if (typeof prompt === 'string') {
					this.lastPrompt = prompt
				}

				this.showAIPrompt = false
				this.isAISuggestionLoading = true
				this.isAIAssistanceRequested = true
				this.aiSuggestionAcceptedTransition = false
				this.$emit('getAISuggestion', this.lastPrompt)

				setTimeout(() => {
					const aiBlock = document.getElementById('ai-suggestion-block')

					if (aiBlock) {
						aiBlock.scrollIntoView({ behavior: 'smooth', block: 'center' })
					}
				}, 100)
			},
			handleHeadingClick() {
				if (this.editor) {
					this.editor
						.chain()
						.focus()
						.toggleHeading({ level: 3 })
						.run()
				}
			},
			handleBoldClick() {
				if (this.editor) {
					this.editor
						.chain()
						.focus()
						.toggleBold()
						.run()
				}
			},
			handleStrikeClick() {
				if (this.editor) {
					this.editor
						.chain()
						.focus()
						.toggleStrike()
						.run()
				}
			},
			handleItalicClick() {
				if (this.editor) {
					this.editor
						.chain()
						.focus()
						.toggleItalic()
						.run()
				}
			},
			handleBulletListClick() {
				if (this.editor) {
					this.editor
						.chain()
						.focus()
						.toggleBulletList()
						.run()
				}
			},
			handleVariableItemClick(item) {
				if (this.editor) {
					this.editor
						.chain()
						.focus()
						.insertContent(`<variable-item id='${item.id}' name='${item.name}' class='para-2'></variable-item>`)
						.run()
				}
			},
			doneEditing() {
				this.$emit('done')
			},
		},
	}
</script>
<style lang="scss" scoped>
	.button-list {
		display: flex;
		align-items: center;
		gap: 4px;
	}
	.menu-bar,
	.p-editor {
		border-radius: 0;
	}
	.menu-bar-container {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1000;
		background-color: var(--stan-white);
		border-bottom: 1px solid var(--stan-gray-strike-color);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
	.menu-bar {
		position: absolute;
		border-bottom: 1px solid #f3f6fd;
		height: 64px;
		background-color: var(--stan-white);
		border-bottom: 1px solid var(--stan-gray-strike-color);
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		width: 100%;
		transition: margin-top 0.15s ease;

		&.down {
			position: fixed;
			top: 0;
		}
	}

	.p-editor {
		padding: 15px;
		background-color: var(--stan-white);
	}

	.menu-button {
		cursor: pointer;
		width: 30px;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 6px;
		margin-bottom: 6px;
	}

	.tiptap-editor-ai-button.button-wrap.button-sm::v-deep {
		min-width: auto;
		padding: 0 8px;

		.button-content .button-icon {
			margin-right: 4px;
			transform: none;

			.icon-svg {
				width: 24px;
				height: 24px;
			}
		}
	}

	@media screen and (max-width: 576px) {
		.tiptap-editor-ai-button.button-wrap.button-sm::v-deep {
			padding: 0px 3px;

			.button-content .button-icon {
				margin-right: 0px;
			}

			.ai-button-text {
				display: none;
			}
		}

		.tiptap-editor-ai-button.loading.button-wrap.button-sm::v-deep {
			padding: 0px 8px;
		}
	}

	.p-editor::v-deep {
		p {
			margin-bottom: 0;
			font-size: 0.875rem;
			line-height: 1.125rem;
		}
	}

	.personalize-link {
		-webkit-appearance: none;
	}

	.editor__content::v-deep {
		padding: 0;

		.ProseMirror-focused {
			outline-width: 0;
			outline: none;
		}

		.ProseMirror {
			border: none;
			margin-top: 4px; // a hack to leave some space above the text in tiptap editor

			> * + * {
				margin-top: 1.25em;
			}

			ul,
			ol {
				padding: 0 1rem;
			}

			h1,
			h2,
			h3,
			h4,
			h5,
			h6 {
				line-height: 1.1;
			}

			code {
				background-color: rgba(#616161, 0.1);
				color: #616161;
			}

			pre {
				background: #0d0d0d;
				color: var(--stan-white);
				font-family: 'JetBrainsMono', monospace;
				padding: 0.75rem 1rem;
				border-radius: 0.5rem;

				code {
					color: inherit;
					padding: 0;
					background: none;
					font-size: 0.8rem;
				}
			}

			img {
				max-width: 100%;
				height: auto;
			}

			blockquote {
				padding-left: 1rem;
				border-left: 2px solid rgba(#0d0d0d, 0.1);
			}

			hr {
				border: none;
				border-top: 2px solid rgba(#0d0d0d, 0.1);
				margin: 2rem 0;
			}

			ul,
			li {
				padding: revert;
			}

			::marker {
				color: var(--tip-tap-accent-color);
			}
		}

		/* Placeholder (on every new line) */
		.ProseMirror p.is-editor-empty:first-child::before {
			content: attr(data-placeholder);
			float: left;
			color: var(--stan-text-light-color) !important;
			pointer-events: none;
			height: 0;
		}

		.ProseMirror_readonly {
			.editor__content {
				width: 100px;
				.ProseMirror {
					overflow-y: unset !important;
					height: auto !important;

					::marker {
						color: inherit !important;
					}

					ul {
						li {
							p {
								text-align: left;
							}
						}
					}
				}
			}
		}

		.ProseMirror {
			overflow-y: auto;
			height: var(--tip-tap-editor-height);
			width: var(--tip-tap-editor-width);
		}

		.flexible {
			.ProseMirror {
				height: auto;
				min-height: var(--tip-tap-editor-height);
				min-width: var(--tip-tap-editor-width);
			}
		}

		.variable-item {
			display: inline-flex;
			padding: 3px;

			background-color: var(--stan-primary-light-color);
			border-radius: 5px;
			cursor: grab;
			user-select: all;

			.content {
				flex: 1 1 auto;
				line-height: 1;
			}
		}

		.ProseMirror ol,
		.ProseMirror ul {
			padding: 0 2rem !important;
		}

		[data-youtube-video] {
			max-width: 600px;
			width: 100%;
			aspect-ratio: 1.5;
		}
	}

	.restore-button {
		font-size: 0.875rem;
	}

	@keyframes float {
		from {
			opacity: 0;
			transform: translateY(-20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.ai-block {
		animation: float 0.3s ease;
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 18px 20px;
		gap: 15px;
		background: #f9f9ff;
		border-radius: 10px;
		margin-top: 20px;

		&.error {
			background: #fff2f2;
		}

		&.h-0 {
			height: 0;
		}

		.loading {
			display: flex;
			width: 100%;
			align-items: center;

			.icon {
				align-items: center;
				display: flex;
			}

			.text {
				flex-grow: 1;
			}

			.cancel {
				color: #ff5050;
				cursor: pointer;
			}
		}

		.error {
			display: flex;
			align-items: center;
			gap: 20px;
			width: 100%;

			.text {
				flex-grow: 1;
			}

			.try-again {
				color: #ff5050;
				cursor: pointer;
			}
		}

		.suggestion {
			display: flex;
			align-items: flex-start;
			gap: 20px;

			.icon {
				svg {
					height: auto;
					width: 28px;
				}
			}

			.text {
				color: var(--stan-primary-dark-color);

				.buttons {
					display: flex;
					gap: 10px;
					margin-top: 25px;
				}
			}
		}
	}

	.disabled {
		opacity: 0.6;
		pointer-events: none;
	}

	.tiptap-editor-subject::v-deep {
		.p-editor {
			padding: 10px 15px 5px 15px;
		}
	}

	.bottom-options {
		display: flex;
		justify-content: space-between;
	}
	.character-count-container {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
	}

	.character-count {
		display: block;
		text-align: right;
		margin-bottom: 0.5rem;
		color: var(--stan-text-light-color);
	}

	.character-count-error {
		color: var(--stan-negative-primary-color);
	}
	.done-button {
		min-width: unset !important;
		padding-left: 16px !important;
		padding-right: 16px !important;
	}
</style>
